import React, { Component } from "react";
import Card from "../../shared/Card";
import { Link } from "react-router-dom";
import { InfoCircle } from 'react-bootstrap-icons';

const tableBorders = {
  borderTop: "none",
  padding: 0,
};

class CesInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
    };
  }

  render() {
    const cesInfo = (
      <Card
      cardType="default"
      cardHeader={<>CalEnviroScreen 4.0 Results
        <Link to="#" style={{ color: '#FFF' }} onClick={(e) => {
          window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#101", "_blank");
          e.preventDefault();
          }}>
          <span style={{position: "relative", left: "6px", bottom: "4px"}}><InfoCircle/></span>
          </Link>
          </>}
      headerColor="#046B99"
      headerTextColor="white"
      cardColor="white"
      cardBody={
        <div className="ces-info-card">
        {this.props.CENSUS_TRACT ? (
        <div>
          <div><strong>Census Tract: </strong>{this.props.CENSUS_TRACT} (Population: {this.props.POPULATION})</div>          
          <div style={{marginTop: 5, marginBottom: 5}}>The results for each indicator range from 0-100 and represent the percentile ranking of census tract {this.props.CENSUS_TRACT} relative to other census tracts.</div>
        </div>
          ) : null}
        <div className="row">      
          <div className="table-responsive col-md-6">
            <table className="table" style={{ marginBottom: 0 }}>
               <tbody>
               {this.props.CENSUS_TRACT ? (
                 <tr><td colSpan={2}><strong>Overall Percentiles</strong></td></tr> 
               ) : null}
                 {this.props.CES_PCT ? (
                  <tr>
                   <td style={tableBorders}>CalEnviroScreen:</td>
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.CES_PCT}                   
                      </Link>
                    </td>
                  </tr>
                  ) : null}
                                
                  {this.props.POLLUTION_BURDEN ? (
                  <tr>               
                      <td style={tableBorders}>Pollution Burden:</td>             
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.POLLUTION_BURDEN}
                      </Link>
                    </td>
                  </tr>
                  ) : null}

                  {this.props.POPULATION_CHAR ? (
                  <tr>               
                      <td style={tableBorders}>Population Characteristics:</td>             
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.POPULATION_CHAR}
                      </Link>
                    </td>
                  </tr>
                  ) : null}
                  </tbody>
                  </table>
          </div>
          <div className="table-responsive col-md-6">
              <table className="table" style={{ marginBottom: 0 }}>               
                <tbody>
                {this.props.CENSUS_TRACT ? (
                  <tr><td colSpan={2}><strong>Environmental Effects</strong></td></tr>  
                ) : null}
                 {this.props.CLEANUP_SITES ? (
                  <tr>               
                      <td style={tableBorders}>Cleanup Sites:</td>             
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.CLEANUP_SITES}
                      </Link>
                    </td>
                  </tr>
                  ) : null}

                   {this.props.GROUND_WATER ? (
                  <tr>
                   <td style={tableBorders}>Groundwater Threats:</td>
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.GROUND_WATER}
                      </Link>
                    </td>
                  </tr>
                  ) : null}

                {this.props.HAZ_WASTE_PCT ? (
                  <tr>
                   <td style={tableBorders}>Hazardous Waste:</td>
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.HAZ_WASTE_PCT}
                      </Link>
                    </td>
                  </tr>
                  ) : null}

                {this.props.SOLID_WASTE ? (
                  <tr>
                   <td style={tableBorders}>Solid Waste:</td>
                    <td style={tableBorders}>
                      <Link to="#" onClick={(e) => {
                        window.open( "https://calenviroscreen-oehha.hub.arcgis.com/#CalEnviroScreen", "_blank");
                        e.preventDefault();
                      }}>
                        {this.props.SOLID_WASTE}
                      </Link>
                    </td>
                  </tr>
                  ) : null}

                  </tbody></table>
          </div>       
        </div>  
        </div>            
      }
    />
  );

  return <div>{cesInfo}</div>;
}
}

export default CesInfo;
